const main = {
  title: 'italist, ALWAYS LIKE A SALE',
  description:
    'Over 200,000 current fashion products, up to 40% cheaper, express shipped from the best Italian boutiques. Shop 1,000 worldwide luxury designer brands',
};

export default main;
